export function obterListaTipoOperacao() {
  return (
    [
      { label: '0 - Entrada/Aquisição', value: 'ENTRADA' },
      { label: '1 - Saída/Prestação', value: 'SAIDA' },
    ]
  );
}
